export default __webpack_public_path__ + "static/media/3267.012d4622.png";